import Chip from "@mui/material/Chip";
import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LaunchIcon from "@mui/icons-material/Launch";
import InfoIcon from "@mui/icons-material/Info";
import CancelIcon from "@mui/icons-material/Cancel";
import { Tooltip } from "@mui/material";

const statusConfig: any = {
  Acceptable: {
    icon: <CheckCircleIcon />,
    bgColor: "#14aa50"
  },
  Consider: {
    icon: <InfoIcon />,
    bgColor: "#d28200"
  },
  "High Risk": {
    icon: <CancelIcon />,
    bgColor: "#df395a"
  },
  "Fraud Documents": {
    icon: <CancelIcon />,
    bgColor: "#df395a"
  }
};

const CustomChip = ({ status, onClickHandler, headerTag }: any) => {
  const config = statusConfig[status];

  if (!config) return <></>; // invalid status -> render nothing

  const label = status;

  const showChipElement = () => {
    return (
      <Chip
        icon={config.icon}
        label={label}
        size="small"
        deleteIcon={headerTag ? <></> : <LaunchIcon />} // no custom onClick here
        onDelete={(e) => {
          e.stopPropagation();
          onClickHandler(); // your callback
        }}
        sx={{
          backgroundColor: config.bgColor,
          color: "#fff",

          // text
          "& .MuiChip-label": {
            color: "#fff !important",
            fontWeight: 500
          },

          // start icon
          "& .MuiChip-icon": {
            color: "#fff !important"
          },

          // end icon
          "& .MuiChip-deleteIcon": {
            color: "#fff !important",
            cursor: "pointer"
          }
        }}
      />
    );
  };

  const toolTipTitle = "Click to view detailed report in a new tab.";

  return (
    <>
      {headerTag ? (
        showChipElement()
      ) : (
        <Tooltip
          title={toolTipTitle}
          placement="right"
          arrow
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: "#32325d", // custom background
                color: "#fff", // text color
                fontSize: "0.9rem",
                boxShadow: 1
              }
            }
          }}
        >
          {showChipElement()}
        </Tooltip>
      )}
    </>
  );
};

export default CustomChip;
